import { render, staticRenderFns } from "./LoadingLayout.vue?vue&type=template&id=0d811d08&"
import script from "./LoadingLayout.vue?vue&type=script&lang=js&"
export * from "./LoadingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports